export default "__VITE_ASSET__17779ae7__"